import { z } from "zod"

import { defaultMaxLength } from "./schema-constants"

export const emailSchema = z.email().trim().max(defaultMaxLength)
